// extracted by mini-css-extract-plugin
export default {"orders":"Orders_orders__UtMI2","search":"Orders_search__H+9Hb","message":"Orders_message__hZGfE"};